module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.25a3241.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.6.3
 ** module id = 561
 ** module chunks = 1
 **/